import React from 'react';
import { Select } from 'antd';
import { Rule } from 'antd/es/form';
import { NamePath } from 'antd/es/form/interface';

import { FormFieldLabel } from './FormFieldLabel';
import { StyledFormItem } from './FormInput';

export type OptionType = {
  value: string | number;
  content?: React.ReactNode;
};

export type FormSelectProps = {
  name: NamePath;
  label?: string;
  allowClear?: boolean;
  options: OptionType[] | [];
  required?: boolean;
  mode?: 'multiple' | 'tags';
  onChange?: (option: OptionType) => void;
  rules?: Rule[];
  dependencies?: NamePath[];
  preserve?: boolean;
};

export const FormSelect: React.FC<FormSelectProps> = ({
  name,
  label,
  options,
  allowClear = true,
  required,
  onChange,
  rules,
  dependencies,
  preserve,
}) => (
  <StyledFormItem
    name={name}
    label={<FormFieldLabel required={required}>{label}</FormFieldLabel>}
    rules={rules}
    dependencies={dependencies}
    preserve={preserve}
  >
    <Select
      showSearch
      allowClear={allowClear}
      filterOption={(input, option) =>
        (option?.label?.toString() ?? '').toLowerCase().includes(input.toString().toLowerCase())
      }
      options={options.map((option) => ({
        value: option.value,
        label: option.content,
      }))}
      onChange={onChange}
    />
  </StyledFormItem>
);
